import { render, staticRenderFns } from "./ContactsRegistrationGhost.vue?vue&type=template&id=76773050"
import script from "./ContactsRegistrationGhost.vue?vue&type=script&lang=js"
export * from "./ContactsRegistrationGhost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports